import React, { useState, useEffect, useContext } from 'react';
import { Grid, Typography, Snackbar, Container } from '@mui/material'
import { Link } from 'react-router';
import { AppContext } from "../context/app-context";

import SearchRedirectPopularLocationListingItem from './SearchRedirectPopularLocationListingItem';

import '../css/components/popularLocationListings.css';
import { getCities } from './location/requests/location-requests';
import {getErrorMessage} from '../util/NetworkErrorUtil';
import {Helmet} from 'react-helmet-async';
import { usePrerenderReady } from '../hooks/usePrerenderReady';

const DEFAULT_NUM_CITIES = 12;
const DEFAULT_ERROR_MESSAGE = "Failed to fetch popular locations";

interface CityObj {
  id: string;
  city: string;
  rank: number;
  imageUrl: string;
  // Comma-separated "lat,lng" string: the map link for a city that isn't a
  // market (see SearchRedirectPopularLocationListingItem).
  coordinates?: string;
}

interface PopularLocationListingProps {
  numCities?: number;
}

const PopularLocationListing = (props: PopularLocationListingProps) => {
  const [cityLimit, setCityLimit] = useState<number>(DEFAULT_NUM_CITIES);
  const [cities, setCities] = useState<CityObj[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);
  // The landing page's crawler-visible content is this list; snapshot once it settled.
  const [citiesFetched, setCitiesFetched] = useState<boolean>(false);
  usePrerenderReady(citiesFetched);

  const { user, loadingUserDetails } = useContext(AppContext);

  useEffect(() => {
    if (props.numCities) setCityLimit(props.numCities);
  }, [props.numCities]);

  useEffect(() => {
    getCities("RANK", "DESC", 0, cityLimit).then((response) => {
      if (response.body) {
        setCities(response.body.content);
      } else {
        setCities([]);
      }
    }).catch((error) => {
      setShowErrorMessage(true);
      setErrorMessage(`${DEFAULT_ERROR_MESSAGE}: ${getErrorMessage(error)}`);
    }).finally(() => {
      setCitiesFetched(true);
    });
  }, [cityLimit]);

  return (
    <>
      <Helmet>
        <meta name="keywords" content={`truck parking, trailer parking, container storage, ${cities?.map(cityObj => cityObj.city)?.join(", ")} || ''`} />
      </Helmet>
      <Container className='ss-popular-location-list' maxWidth="lg">
        <Grid container className="popular-location-listing-container-grid">
          <Grid item container justifyContent="space-between" alignItems="flex-end">
            <Grid item>
              <Typography variant="h4" className="header1" color="textPrimary">
                Popular Locations
              </Typography>
            </Grid>
            {
              (!user || loadingUserDetails) && <Grid item>
                <Typography variant="subtitle1" className="header2" color="textPrimary">
                  Want to List Your Location Here? <Link to={{ pathname: "/supplier-signup" }} className="sign-up-link">Click here</Link> to sign up
                </Typography>
              </Grid>
            }
          </Grid>
          <Grid className="location-panel-container" item container>
            {
              cities.map((cityObj) => {
                return (
                  <SearchRedirectPopularLocationListingItem cityObj={cityObj} key={cityObj.id} />
                );
              })
            }
          </Grid>
        </Grid>
        {
          showErrorMessage && <Snackbar
            open={showErrorMessage}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            message={errorMessage}
            autoHideDuration={6000}
            onClose={() => setShowErrorMessage(false)}
          />
        }
      </Container>
    </>
  );
};

export default PopularLocationListing;
